export default {
  id: "Customer #", // 864-50-109",
  contentType: "Type", //Bradington-Young",
  realm: "Realm",
  height: "Height",
  width: "Width",
  area: "Area",
  contentLength: "Size",
  clientId: "Client #",
  url: "URL",
  tags: "Tags",
  defaultTags: {},
  readOnlyTags: {
    "Content Type": 1,
    "Image Type": 1,
    Size: 1,
    Parent: 1,
  },
  rating: 0,
  restricted: "Restricted",
  description: "Description",
  label: "CompanyName",
  active: "Status",
  euid: "EUID",
  createdBy: "Created By",
  createdOn: "Created On",
  lastModifiedOn: "Last Mod On",
  lastModifiedBy: "Last Mod By",
  position: "Position", //0,

  ///actions
  hotspotPopoverPosition: "Position",
  autoHotspotAllCustomerPages: "Auto-Hotspot All Customer Pages...",
  autoHotspotSKUs: "Auto-Hotspot SKUs...",
  editCustomerProperties: "Edit Customer Properties...",
  editPageProperties: "Edit Page Properties...",
  shareProductsOnPage: "Share Products on Page...",
  managePage: "Manage Page...",
  manageProducts: "Manage Products...",
  manageCustomer: "Manage Customer...",
  viewYouTubeVideos: "View YouTube Videos...",
  viewPageOverview: "View YouTube Videos...",
  createMultiItemHotspot: "Create a new multi-item hotspot",
  createExternalResource: "Link to an External Resource",
  createYouTubeHotspot: "Create a YouTube hotspot",
  createVideoHotspot: "Create a video hotspot",
  createPageHotspot: "Link to a page",
  addSection: "Add Section...",
  addEmptyPage: false,

  landingPageTagKind: false,

  hotspotIconOffsetX: 10,
  hotspotIconOffsetY: 5,
};
